// extracted by mini-css-extract-plugin
export default {"message":"Message_message__GR0sF","success":"Message_success__m05xg","error":"Message_error__lj+4k"};